<template>
  <div class="assetOperation">
    <div class="mt-8 flex items-center">
      <h1 v-if="operation==='add'" class="text-lg font-bold">新增资产</h1>
      <h1 v-if="operation==='edit'" class="text-lg font-bold">编辑资产</h1>
      <div class="ml-auto">
          <button class="button button--bg mr-1 mb-2 border border-theme-1 text-theme-1 dark:bg-dark-5 dark:text-gray-300" @click="backHandle">返回</button>
          <button class="button button--bg mr-1 mb-2 bg-theme-1 text-white" type='primary' @click="submitHandle">创建完成</button>
      </div>
    </div>
    <div class="mt-5 intro-y box border border-gray-200 dark:border-dark-5 rounded-md p-5">
      <div class="basic-info">
        <!-- <h2>基本信息</h2> -->
        <basic-info-edit ref="basicInfoEdit"/>
      </div>
      <div class="upload-report">
        <upload-assessment-report @uploadComplete='uploadComplete' :evalReport='evalReport'></upload-assessment-report>
      </div>

      <div class="asset-remark mt-5">
        <remark-edit name='资产备注' :remarkVal.sync='remark'></remark-edit>
      </div>

      <!-- 资产附件 -->
      <asset-appendix class="mt-5" name='资产附件' @getAppendixList='getAppendixList' :data.sync='appendixList'></asset-appendix>
    </div>
  </div>
</template>

<script>
import basicInfoEdit from './components/assetOperation/basicInfoEdit'
import assetAppendix from './components/assetOperation/assetAppendix'
import remarkEdit from './components/assetDetail/coms/remarkEdit.vue'
import uploadAssessmentReport from './components/uploadAssessmentReport.vue'
import {addOrUpdate,getDes} from '@/api/asset.js'
  export default {
    name: "assetOperation",
    components: {
      basicInfoEdit,
      assetAppendix,
      remarkEdit,
      uploadAssessmentReport,
    },
    data() {
      return {
        remarkVal:'',
        operation:'add',
        evalReport:[],
        remark:'',
        appendixList:[],
        assetId:'',
        detail:{},
      }
    },
    methods: {
      backHandle(){
        this.$router.go(-1);
      },
      getAppendixList(val){
        this.appendixList=val;
      },
      submitHandle(){
        this.$refs.basicInfoEdit.$refs.ruleForm.validate(valid=>{
          if(valid){
            let para=JSON.parse(JSON.stringify(this.$refs.basicInfoEdit.form));
            para.remark=this.remark;
            para.evalReport=this.evalReport;
            para.extra=this.appendixList;
            para.assetId=this.assetId;
            addOrUpdate(para).then(res=>{
              let data=res.data;
              if(data.code==='000'){
                this.$message.success(data.desc);
                this.$router.go(-1)
              }else{
                console.log(data.desc);
                this.$message.warning(data.desc)
              }
            })
          }else {
            console.log('error submit!!');
            return false;
          }
        })

      },
      addHandle(){},
      uploadComplete(fileList){
        console.log(fileList)
        this.evalReport=fileList;
      },
      getDetail(){
        getDes({assetId:this.assetId}).then(res=>{
          let data=res.data;
          if(data.code==='000'){
            this.detail=data.content.detail;
            this.remark=this.detail.remark;
            this.appendixList=this.detail.extra||[];
            this.evalReport=this.detail.evalReport;
            this.$refs.basicInfoEdit.form=this.detail;

          }else{
            console.log(data.desc)
          }
        })
      }
    },
    created() {
      this.operation=this.$route.query.operation;
      if(this.operation==='edit'){
        this.assetId=this.$route.query.assetId;
        this.getDetail();
      }
    },
  }
</script>
